import { createSlice } from '@reduxjs/toolkit';

import axios from 'axios';
import { dispatch } from '../index';

const initialState = {
    error: null,
    creativeInfo: null,
    creativeTemplateList: [],
    assetList: null
};

// ==============================|| SLICE - CREATIVE EDIT ||============================== //

const slice = createSlice({
    name: 'creativeEdit',
    initialState,
    reducers: {
        hasError(state, action) {
            if(action.payload.response ? (action.payload.response.status == 401) : (action.payload.status == 401)) {
                window.location.pathname = 'login'
            } else {
                state.error = action.payload;
            }
        },
        setCreativeInfo(state, action) {
            state.creativeInfo = action.payload;
        },
        setCreativeTemplateList(state, action) {
            state.creativeTemplateList = action.payload;
        },
        addToCreativeTemplateList(state, action) {
            state.creativeTemplateList = [...state.creativeTemplateList, action.payload]
        },
        setAssetList(state, action) {
            state.assetList = action.payload;
        }
    }
});

export default slice.reducer;

export function getCreativeInfo(data, callback) {
    return async () => {
        try {
            const response = await axios.get(`/api/campaign/creative/details/${data}`, {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
                    'X-Workspace-ID': localStorage.getItem('workspaceId')
                }
            });
            dispatch(slice.actions.setCreativeInfo(response.data.creative));
            if (callback) {
                callback();
            }
        } catch (e) {
            dispatch(slice.actions.hasError(e));
        }
    };
}

export function combineImage(data, callback) {
    return async () => {
        try {
            const response = await axios.post('/api/campaign/creative/combine-image', data, {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
                    'X-Workspace-ID': localStorage.getItem('workspaceId')
                }
            });
            if (callback) {
                callback();
            }
        } catch (e) {
            dispatch(slice.actions.hasError(e));
        }
    };
}

export function updateCreative(data, callback) {
    return async () => {
        try {
            const response = await axios.post('/api/campaign/creative/update', data, {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
                    'X-Workspace-ID': localStorage.getItem('workspaceId')
                }
            });
            if (callback) {
                callback();
            }
        } catch (e) {
            dispatch(slice.actions.hasError(e));
        }
    };
}

export function assetUpload(data, callback) {
    return async () => {
        try {
            const response = await axios.post('/api/asset/upload', data, {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
                    'Content-Type': 'multipart/form-data',
                    'X-Workspace-ID': localStorage.getItem('workspaceId')
                }
            });
            if (callback) {
                callback();
            }
        } catch (e) {
            dispatch(slice.actions.hasError(e));
        }
    };
}

export function getAssetList(data, callback) {
    return async () => {
        try {
            const response = await axios.post('/api/asset/list', data, {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
                    'X-Workspace-ID': localStorage.getItem('workspaceId')
                }
            });
            dispatch(slice.actions.setAssetList(response.data.assetList));
            if (callback) {
                callback();
            }
        } catch (e) {
            dispatch(slice.actions.hasError(e));
        }
    };
}

export function assetUpdate(data, callback) {
    return async () => {
        try {
            const response = await axios.post('/api/asset/update', data, {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
                    'X-Workspace-ID': localStorage.getItem('workspaceId')
                }
            });
            if (callback) {
                callback();
            }
        } catch (e) {
            dispatch(slice.actions.hasError(e));
        }
    };
}

export function getTemplate(data, callback) {
    return async () => {
        try {
            const response = await axios.post('/api/template/list', data, {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
                    'X-Workspace-ID': localStorage.getItem('workspaceId')
                }
            });
            dispatch(slice.actions.setCreativeTemplateList(response.data.creativeTemplateList));
            if (callback) {
                callback(response.data.creativeTemplateList);
            }
        } catch (e) {
            dispatch(slice.actions.hasError(e));
        }
    };
}

export function createTemplate(data, callback) {
    return async () => {
        try {
            const response = await axios.post('/api/template/create', data, {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
                    'X-Workspace-ID': localStorage.getItem('workspaceId')
                }
            });
            dispatch(slice.actions.addToCreativeTemplateList(response.data.creativeTemplate));
            if (callback) {
                callback(response.data.creativeTemplateList);
            }
        } catch (e) {
            dispatch(slice.actions.hasError(e));
        }
    };
}

export function generateTagline(data, callback) {
    return async () => {
        try {
            const response = await axios.post('/api/campaign/creative/generate-tagline', data, {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
                    'X-Workspace-ID': localStorage.getItem('workspaceId')
                }
            });
            if (callback) {
                callback(response.data);
            }
        } catch (e) {
            dispatch(slice.actions.hasError(e));
        }
    };
}
